import { Role, UserTier, UserWithMeta } from 'src/common-services'
import isChromatic from 'chromatic'
import React from 'react'
import { MutableSnapshot, RecoilRoot } from 'recoil'
import { mockUser } from 'src/atoms/user'

const userMock: UserWithMeta = {
  id: 'mock-user-id',
  created: new Date(),
  email: 'mock@alphamap.com',
  enabled: true,
  paymentMethod: 'direct',
  plan: 'standard',
  lastLogin: new Date(),
  role: Role.user,
  expires: new Date(),
  tier: 'premium',
  firstName: 'Mock',
  lastName: 'User',
}

type RootProps = {
  children?: React.ReactNode
  initializeState?: (mutableSnapshot: MutableSnapshot) => void
  tier?: UserTier
}

export const RecoilRootWithMockUser = (props: RootProps) => {
  const initialize = (snap: MutableSnapshot) => {
    snap.set(mockUser, {
      ...userMock,
      tier: props.tier || 'premium',
    })
    if (props.initializeState) {
      props.initializeState(snap)
    }
  }
  return (
    <RecoilRoot {...props} initializeState={initialize}>
      {props.children}
    </RecoilRoot>
  )
}

export function isInStorybook(): boolean {
  if (typeof process === 'undefined') {
    return false
  }
  return Boolean(process?.env?.STORYBOOK)
}

export function isInScreenshots(): boolean {
  return isChromatic()
}
